import React, { useState, useEffect } from 'react'
import { CommonApiService } from '../../../_services/CommnService/CommonApiService'
import DropDown from '../../../_components/_common/DropDown/DropDown'
import { Validation } from '../../../_helpers/validation/Validation'
import LoaderWithLogo from '../../../_components/Loader/LoaderWithLogo'
import { AiFillExclamationCircle } from "react-icons/ai";

const BrokerRegistration = (props) => {
  // const [userType, setUserType] = useState([])
  const [type, setType] = useState("Broker")
  const [stateArray, setStateArray] = useState([])
  const [state, setStates] = useState("")
  const [pan, setPan] = useState("")
  const [aadhaar, setAadhaar] = useState("")
  const [isLoading, setLoader] = useState(false)
  const [error, setError] = useState("")
  const [isComingFromLast, setIsComingFromLast] = useState(false)
  const [isAadhaarOrPan, setIsAadhaarOrPan] = useState("pan")

  useEffect(() => {
    if (Array.isArray(stateArray) && stateArray.length === 0) {
      getState()
    }
  }, [props.dataForSignUp])
  
  const getState = async () => {
    await CommonApiService.getStatesOfCountry().then(response => {
      if (response && response.data && response.data.data) {
        let stateArr = [{ value: null, label: "Please Select State ..." }].concat(response.data.data)
        setStateArray(stateArr)
      }
    })
  }


  useEffect(() => {
    if (type) {
      setLoader(true)
      CommonApiService.userType({ "user_type": type }).then(res => {
        setLoader(false)
        if (props.noKYC) {
          props.close()
        }
      }).catch(() => {
        setLoader(false)
      })
    }
  }, [type])

  useEffect(() => {
    if (props.yourDetails) {
      setIsComingFromLast(true)
      setPan(props.yourDetails.pan_number ? props.yourDetails.pan_number : "")
      setStates(props.yourDetails.state)
      setTimeout(() => {
        setIsComingFromLast(false)
      }, 200)
    }
  }, [props.yourDetails])

  useEffect(()=>{
    let err = { pan_number: props.penError ? props.penError : "" }
    if (props.penError) {
      setError(err)
    }
  },[props.penError])

  useEffect(() => {
    if (type !== "") {
      setIsAadhaarOrPan("")
    }
    if (type !== "") {
      props.onChangeType(type)
      setError("")
    }
  }, [type])

  useEffect(() => {
    if (!isComingFromLast) {
      setPan("")
      setStates("")
      props.onChangeType("")
    }
  }, [props.type])

 
  const onchangeState = (e) => {
    setStates(e.value)
  }

  const onSubmit = () => {
    let flag = 0
    let data = {
      "pan_number": isAadhaarOrPan === "pan" && pan ? pan : null,
      "aadhar_number": isAadhaarOrPan === "aadhaar" && aadhaar ? aadhaar : "",
      "user_type": type,
      "state": isAadhaarOrPan === "pan" && state,
      "pan_image": "",
      "aadhar_front_image": "",
      "aadhar_back_image":  "",
      aadhaarFrontImageBase64: "",
      aadhaarBackImageBase64: ''
    }
    let obj = Validation(data, rules)

    if (type !== "" && pan === "") {
 
      if(isAadhaarOrPan === "pan")
             obj.pan_number = `PAN Number is Required!`;
    }

    setError(obj)
    Object.keys(obj).forEach(index => {
      if (obj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      props.pageDetails(data)
    }
  }

  const onKeyPressSubmit = (e) => {
    if (e.key === 'Enter')
      onSubmit()
  }
  


  return <div className="filterbx p-0">
    <LoaderWithLogo isLoading={isLoading}></LoaderWithLogo>

    <div className="radioselectuser">
      <div className="select-title">
        <h3>User Type - BROKER</h3>
      </div>
    </div>

  <div className="form-group mt-4">
      <div className="farmer_aadhar">
        <div className="poxlogin" style={{ width: '100%' }}>
          <input
            name="first_name"
            type="text"
            className={error && error.pan_number && error.pan_number !== "" ? "poxinput-error" : "poxinput"}
            id=""
            onChange={e => setPan(e.target.value.toUpperCase(), setIsAadhaarOrPan("pan"))}
            onKeyPress={onKeyPressSubmit}
            value={pan}
            required
          // readOnly={isAadhaarOrPan === ""}
          />
          {error && error.pan_number && error.pan_number !== "" && <AiFillExclamationCircle size={25} className="poxinput-excl"></AiFillExclamationCircle>}
          <label className={error && error.pan_number && error.pan_number !== "" ? "poxlabel-error" : "poxlabel"}>Enter your PAN number</label>
          {error && error.pan_number !== "" && (
            <div className="fromerror">{error.pan_number}</div>)}
        </div>
      </div>
    </div>

     <div className="form-group mt-4 pologin">
      <div className="polabel">If Registered for GST, Please Choose Your State</div>
      {stateArray && <DropDown preselected={state} options={stateArray} onChange={onchangeState} isDisabled={isAadhaarOrPan === ""} onKeyPress={onKeyPressSubmit} />}
      {error && error.state !== "" && (
        <div className="fromerror">{error.state}</div>)}
    </div>
    
    <div className="mt-4">
      <a className="form-control posubmit" style={{ backgroundColor: "#e08701", textAlign: 'center', color: "#fff", fontWeight: '600', cursor: 'pointer' }} onClick={() => onSubmit()}>CONTINUE</a>
    </div>
  </div>
}
export default BrokerRegistration

const rules = [{
  field_name: 'user_type',
  label: 'User Type',
  type: "string",
  isRequired: true
},
{
  field_name: 'pan_number',
  label: 'PAN Number',
  type: "pan",
  isRequired: false
}]